import React, { useState, useEffect } from "react";
import useFetch from "../../../../hooks/useFetch";

const ReunionLanguageSelect = ({ onSelect }) => {
  const { fetchData } = useFetch();
  const [languages, setLanguages] = useState([]);
  const [chosen, setChosen] = useState("en");
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await fetchData({
        url: "/reunion/game/languages",
        method: "GET",
      });
      if (response?.status) setLanguages(response.data);
    })();
    // eslint-disable-next-line
  }, []);

  const handleStart = async () => {
    setStarting(true);
    await onSelect(chosen);
    setStarting(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md p-8 text-center">
        <div className="text-6xl mb-4">🌐</div>
        <h1 className="text-2xl font-black mb-2">Choose Your Language</h1>
        <p className="text-emerald-200 text-sm mb-6">
          Questions will show in English, plus the language you pick — you can
          only choose once, right before the game starts.
        </p>

        <select
          value={chosen}
          onChange={(e) => setChosen(e.target.value)}
          className="w-full rounded-xl bg-black/30 border border-white/10 px-4 py-1 mb-6"
        >
          {languages.map((l) => (
            <option key={l.code} value={l.code}>
              {l.label}
            </option>
          ))}
        </select>

        <button
          onClick={handleStart}
          disabled={starting}
          className="w-full rounded-2xl py-4 bg-gradient-to-r from-emerald-500 to-green-600 font-bold text-lg disabled:opacity-50"
        >
          {starting ? "Starting..." : "🚀 Start Playing"}
        </button>
      </div>
    </div>
  );
};

export default ReunionLanguageSelect;
